import { render } from "./Index.vue?vue&type=template&id=2043de4d"
const script = {}

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__